var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cog-checkable cog-input",
      class: [
        _vm.allowOther && "cog-checkable--allow-other",
        _vm.hasColumns ? _vm.columnClasses : "cog-checkable--inline",
        _vm.readonly && "is-read-only",
        _vm.isCard && "cog-checkable--card",
        _vm.cardLabelPosition === "bottom" && "cog-checkable--label-on-bottom",
        _vm.hasAtLeastOneImage && _vm.choiceImageSizeClass,
        _vm.isPersonField && _vm.hasAtLeastOneImage && "cog-checkable--avatars"
      ]
    },
    [
      _vm.readonly
        ? _c("div", { staticClass: "cog-checkable__item is-read-only" }, [
            _c("div", { staticClass: "cog-choice-option" }, [
              _vm.selectedImage.value
                ? _c(
                    "div",
                    { staticClass: "cog-choice-image-container" },
                    [
                      _vm.isSvg(_vm.selectedImage.value)
                        ? _c("c-generated-avatar", {
                            attrs: { svg: _vm.selectedImage.value }
                          })
                        : _vm.selectedImage.type === "choiceImage"
                        ? _c("img", {
                            staticClass: "cog-choice-image",
                            attrs: {
                              src: _vm.selectedImage.value,
                              alt: _vm.displayValue,
                              width:
                                _vm.selectedImage.choiceImageDimensions &&
                                _vm.selectedImage.choiceImageDimensions.width,
                              height:
                                _vm.selectedImage.choiceImageDimensions &&
                                _vm.selectedImage.choiceImageDimensions.height
                            }
                          })
                        : _c("img", {
                            class: [
                              "cog-lookup-image",
                              { "cog-avatar": _vm.isPersonField }
                            ],
                            attrs: {
                              src: _vm.selectedImage.value,
                              alt: _vm.displayValue,
                              height: _vm.isPersonField ? 50 : null,
                              width: _vm.isPersonField ? 50 : null
                            }
                          })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideChoiceLabels || !_vm.selectedImage.value
                ? _c("div", [
                    _c("span", { staticClass: "cog-choice__value" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("spaceIfEmpty")(
                            _vm._f("breakWords")(
                              _vm.selectedValue && _vm.selectedValue.label
                                ? _vm.selectedValue.label
                                : _vm.displayValue
                            )
                          )
                        )
                      )
                    ]),
                    _vm.isCard && _vm.selectedValue.description
                      ? _c("span", { staticClass: "cog-choice__description" }, [
                          _vm._v(_vm._s(_vm.selectedValue.description))
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ])
        : _c(
            "el-radio-group",
            {
              attrs: { role: null, label: null },
              on: { change: _vm.handleChange },
              model: {
                value: _vm.internalValue,
                callback: function($$v) {
                  _vm.internalValue = $$v
                },
                expression: "internalValue"
              }
            },
            [
              _vm._l(_vm.options, function(item, i) {
                return _c(
                  "el-radio",
                  {
                    key: item.value,
                    staticClass: "cog-checkable__item cog-choice-option",
                    class: [
                      { "cog-inner-col__item": _vm.hasColumns },
                      {
                        "cog-checkable__item--no-label":
                          _vm.hideChoiceLabels && item.choiceThumbnailImage
                      }
                    ],
                    style: `order: ${_vm.optionOrder[i]}`,
                    attrs: {
                      label: item.value,
                      value: item.value,
                      align: true
                    },
                    nativeOn: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar"
                          ])
                        )
                          return null
                        return _vm.handleRadioSpace.apply(null, arguments)
                      },
                      click: function($event) {
                        return _vm.$emit("focus-lost")
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        !_vm.isCard && _vm.hasImage(item)
                          ? {
                              key: "image",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "cog-choice-image-container"
                                    },
                                    [
                                      item.svg
                                        ? _c("c-generated-avatar", {
                                            attrs: {
                                              svg: item.svg,
                                              alt: item.displayValue
                                            }
                                          })
                                        : item.thumbnailImage
                                        ? _c("img", {
                                            class: [
                                              "cog-lookup-image",
                                              {
                                                "cog-avatar": _vm.isPersonField
                                              }
                                            ],
                                            attrs: {
                                              src: _vm.imagesInChoiceFieldsEnabled
                                                ? item.fullSizeImage
                                                : item.thumbnailImage,
                                              alt: item.displayValue,
                                              width: _vm.isPersonField
                                                ? 50
                                                : null,
                                              height: _vm.isPersonField
                                                ? 50
                                                : null
                                            }
                                          })
                                        : item.choiceThumbnailImage
                                        ? _c("img", {
                                            staticClass: "cog-choice-image",
                                            attrs: {
                                              alt: item.displayValue,
                                              width:
                                                item.choiceImageDimensions
                                                  .width,
                                              height:
                                                item.choiceImageDimensions
                                                  .height,
                                              src: _vm.imagesInChoiceFieldsEnabled
                                                ? item.choiceFullSizeImage
                                                : item.choiceThumbnailImage
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm.isCard
                      ? [
                          item.svg
                            ? _c("c-generated-avatar", {
                                staticClass: "cog-choice-image",
                                attrs: { svg: item.svg }
                              })
                            : item.thumbnailImage
                            ? _c("img", {
                                class: [
                                  "cog-choice-image",
                                  "cog-lookup-image",
                                  { "cog-avatar": _vm.isPersonField }
                                ],
                                attrs: {
                                  src: _vm.imagesInChoiceFieldsEnabled
                                    ? item.fullSizeImage
                                    : item.thumbnailImage,
                                  alt: item.displayValue,
                                  height: _vm.isPersonField ? 50 : null,
                                  width: _vm.isPersonField ? 50 : null
                                }
                              })
                            : item.choiceThumbnailImage
                            ? _c("img", {
                                staticClass: "cog-choice-image",
                                attrs: {
                                  alt: item.displayValue,
                                  src: _vm.imagesInChoiceFieldsEnabled
                                    ? item.choiceFullSizeImage
                                    : item.choiceThumbnailImage
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !(_vm.hideChoiceLabels && _vm.hasImage(item))
                            ? _c("div", [
                                _c(
                                  "span",
                                  { staticClass: "cog-choice__value" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("breakWords")(
                                          item.label
                                            ? item.label
                                            : item.displayValue
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                item.description
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "cog-choice__description"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.cleanChoiceDescription(
                                              item.description
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._v(" "),
                    !_vm.isCard && !(_vm.hideChoiceLabels && _vm.hasImage(item))
                      ? [
                          _c("span", { staticClass: "cog-choice__value" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("breakWords")(
                                  item.label ? item.label : item.displayValue
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          item.description
                            ? _c(
                                "span",
                                { staticClass: "cog-choice__description" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.cleanChoiceDescription(
                                        item.description
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.allowOther
                ? _c(
                    "el-radio",
                    {
                      ref: "otherRadio",
                      staticClass:
                        "cog-checkable__item cog-choice-option cog-checkable__allow-other",
                      class: _vm.hasColumns ? "cog-inner-col__item" : null,
                      style: `order: ${_vm.optionOrder[_vm.options.length]}`,
                      attrs: { label: _vm.otherValue },
                      on: { change: _vm.handleOtherRadioChange },
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleOtherRadioClick.apply(
                            null,
                            arguments
                          )
                        }
                      }
                    },
                    [
                      _c("el-input", {
                        ref: "otherInput",
                        attrs: {
                          tabindex: _vm.otherIsSelected ? "0" : "-1",
                          placeholder: _vm.$resource(
                            "field-choice-other-fill-in"
                          )
                        },
                        on: {
                          focus: _vm.handleOtherFocus,
                          blur: _vm.handleOtherBlur,
                          input: _vm.handleOtherInput
                        },
                        model: {
                          value: _vm.otherValue,
                          callback: function($$v) {
                            _vm.otherValue = $$v
                          },
                          expression: "otherValue"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }